import { render, staticRenderFns } from "./AdminProductionTypeAddModal.vue?vue&type=template&id=73c6f353"
import script from "./AdminProductionTypeAddModal.vue?vue&type=script&lang=js"
export * from "./AdminProductionTypeAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73c6f353')) {
      api.createRecord('73c6f353', component.options)
    } else {
      api.reload('73c6f353', component.options)
    }
    module.hot.accept("./AdminProductionTypeAddModal.vue?vue&type=template&id=73c6f353", function () {
      api.rerender('73c6f353', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminProductionTypeAddModal.vue"
export default component.exports